// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { notification } from "antd";
import { http } from "../../../engine/api/http";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import routes from "../../../engine/routes";
import dayjs from "../../../utils/dayjs";
import { router } from "../../../engine/router/AppRouter";

const initialState = {
  bill: {
    _id: undefined,
    prestations: [],
    institution: null,
    costs: [],
    costParams: {},
    amount: 0,
    swico: "",
    reference: "",
    bill_number: 0,
    createdAt: null,
  },
  loading: false,
};

export const getBill = createAsyncThunk(
  "bill/getBill",
  async (billId, thunkAPI) => {
    const res = await http.get("/bills/" + billId);
    return res.data;
  },
);

export const getSchedules = createAsyncThunk(
  "bill/getSchedules",
  async (billId, thunkAPI) => {
    const res = await http.get("/schedules/user/" + billId);

    return res.data;
  },
);

export const updateBill = createAsyncThunk(
  "bill/updateBill",
  async (payload, thunkAPI, state) => {
    const bill = thunkAPI.getState().bill.bill;
    const res = await http.patch("/bills/" + bill._id, bill);
    notification.success({
      message: `Facture modifiée`,
    });
    return res.data;
  },
);

export const saveSchedules = createAsyncThunk(
  "bill/saveSchedules",
  async (payload, thunkAPI, state) => {
    const schedules = thunkAPI.getState().bill.schedules;
    const _id = thunkAPI.getState().bill.bill._id;

    const res = await http.patch("/schedules", schedules);
    notification.success({
      message: `Disponiblitées sauvegardées`,
    });

    thunkAPI.dispatch(getSchedules(_id));

    return res.data;
  },
);

export const deleteSchedule = createAsyncThunk(
  "bill/deleteSchedule",
  async (payload, thunkAPI, state) => {
    const res = await http.delete(`/schedules/${payload}`);
    notification.success({
      message: `Absences supprimées`,
    });
    return res.data;
  },
);

const billSlice = createSlice({
  name: "bill",
  initialState,
  reducers: {
    clearBill: state => {
      return initialState;
    },
    setPropertiesBill: (state, action) => {
      state.bill = { ...state.bill, ...action.payload };
    },
    pushNewSchdedule: (state, action) => {
      state.schedules.push(action.payload);
    },
  },
  extraReducers: {
    [getBill.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getBill.fulfilled]: (state, { payload }) => {

      if (payload === "") {
        notification.error({
          message: "Cette facture n'existe pas.",
        });
        router.navigate("/", { replace: true });
      }
      state.loading = false;
      state.bill = payload;
    },
    [getSchedules.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.schedules = payload;
    },
    [updateBill.pending]: (state, { payload }) => {},
    [getSchedules.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [updateBill.fulfilled]: (state, { payload }) => {
      state.bill = payload;
    },
    [getBill.rejected]: state => {
      state.loading = false;
    },
    [getSchedules.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export const initBillSlice = ({}) => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { bill } = useSelector(state => state.bill);
  const navigate = useNavigate();

  const init = () => {
    if (id !== "new") {
      dispatch(getBill(id));
    }
  };

  const clear = () => {
    dispatch(clearBill());
  };

  useEffect(() => {
    if (bill._id !== undefined && id === "new") {
      navigate(routes.bills(bill._id).detail.path, {
        replace: true,
      });
    }
  }, [bill]);

  useEffect(() => {
    init();

    if (id === "new" && bill._id !== undefined && bill._id !== id) {
      // Reset when go to a new one
      clear();
      navigate(routes.billing().new.path, {
        replace: true,
      });
    }

    return () => {
      // clear();
    };
  }, []);

  return { init, clear };
};

export const {
  pushNewSchdedule,
  clearBill,
  setPropertiesBill,
} = billSlice.actions;

export const billReducer = billSlice.reducer;
